module.exports = __webpack_public_path__ + "img/diamante.09b45fa1.png";